import { useTranslation } from 'react-i18next';
import type { PublicBank } from '@/lib/transferApi';

export default function BankIdentity({ bank }: { bank: PublicBank }) {
  const { t } = useTranslation();

  return (
    <aside className="rounded-3xl bg-foreground-950 p-6 md:p-8 flex flex-col gap-6">
      <div>
        <p className="text-[10.5px] font-semibold uppercase tracking-[0.16em] text-background-50/50 font-label">
          {t('flow.bankPanelTitle')}
        </p>
        <div className="mt-4 flex items-center gap-3">
          <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-background-50 text-foreground-950 text-[15px] font-bold font-heading shrink-0">
            {bank.initials}
          </span>
          <div className="min-w-0">
            <p className="text-[16px] font-semibold text-background-50 font-heading truncate">{bank.name}</p>
            <p className="mt-0.5 text-[11.5px] text-background-200/70 truncate">
              {[bank.country, bank.swift].filter(Boolean).join(' · ') || '—'}
            </p>
          </div>
        </div>
      </div>

      <div className="h-px bg-background-50/10" />

      <ul className="flex flex-col gap-2.5">
        {[
          { icon: 'ri-shield-check-line', label: t('flow.secure1') },
          { icon: 'ri-bank-line', label: t('flow.secure2') },
          { icon: 'ri-history-line', label: t('flow.secure3') },
        ].map((item) => (
          <li key={item.label} className="flex items-center gap-2.5">
            <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-background-50/10 text-accent-300 shrink-0">
              <i className={`${item.icon} text-sm`} aria-hidden="true" />
            </span>
            <span className="text-[12.5px] text-background-200 font-label">{item.label}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto flex items-start gap-2 rounded-xl border border-background-50/15 bg-background-50/10 px-3.5 py-3">
        <span className="flex items-center justify-center w-4 h-4 mt-0.5 shrink-0 text-background-200/80">
          <i className="ri-lock-2-line text-[13px]" aria-hidden="true" />
        </span>
        <p className="text-[11.5px] leading-relaxed text-background-200/70">{t('flow.footnote')}</p>
      </div>
    </aside>
  );
}